import React from 'react';
import moment from 'moment'

const ShowOrgProjects = ({projects, profile }) => {
// console.log(projects)
    return (
        <div>
            {projects?.map((project, index)=>{
                return(
                    <div
                    key={index}
                    className="bg-gray-50 rounded-lg"
                    style={{marginBottom: '10px'}}
                    >
                        <div className="px-4 py-5 sm:p-6">
                            <p
                            className="float-right border-2 border-gray-400 rounded-md px-2 -mt-2 bg-green-600 text-white font-bold"
                            >
                                {project?.ProspectInterestUsed?.activity_status?.length > 0 ?
                                <span>
                                    Recent Activity
                                </span>
                                :
                                <span>
                                    {project?.ProspectInterestUsed}
                                </span>
                                }
                            </p>
                            <p 
                            style={{
                                fontWeight: 700,
                                fontSize: 15,
                                marginBottom: '5px'
                            }}
                            >
                                {project?.ProspectName}
                            </p>
                            
                            <p 
                            className="whitespace-normal"
                            >
                                {project?.ProspectContent}
                            </p>
                            <p className="text-sm text-gray-500 truncate mt-2">
                                {project?.CreatedAt ? 
                                    <span>{moment(project?.CreatedAt?.toDate()).calendar()}</span>
                                :
                                    <span>{moment(project?.createdAt?.toDate()).calendar()}</span>
                                }
                            </p>
                        </div>  
                    </div>
                )
            })}
            
        </div>
    )
}

export default ShowOrgProjects
